import React, { Component } from 'react';
import { FilePond } from 'react-filepond';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import ToastrService from '../services/ToastrService';

const messages = defineMessages({
  FileIsTooLarge: 'File is too large',
  DragDropFiles: 'Drag & Drop your files or',
  Browse: 'Browse',
  FileWaitingForSize: 'Waiting for size',
  FileSizeNotAvailable: 'Size not available',
  Loading: 'Loading',
  FileLoadError: 'Error during load',
  Uploading: 'Uploading',
  FileProcessingComplete: 'Upload complete',
  FileProcessingAborted: 'Upload cancelled',
  FileProcessingError: 'Error during upload',
  TapToCancel: 'tap to cancel',
  TapToRetry: 'tap to retry',
  TapToUndo: 'tap to undo',
  Remove: 'Remove',
  Abort: 'Abort',
  Retry: 'Retry',
  Cancel: 'Cancel',
  Undo: 'Undo',
  Upload: 'Upload',
  MaxFileSize: 'Maximum file size is {filesize}',
  FileTypeNotAllowed: 'This file type is not allowed',
  MaxFilesOf50Exceeded: 'Maximum number of files of 50 exceeded',
});

class TranslatedFilePond extends Component {
  getLabels = intl => ({
    labelIdle: `
      <b>${intl.formatMessage(
        messages.DragDropFiles,
      )} <span class="filepond--label-action">${intl.formatMessage(messages.Browse)}</span>
    `,
    labelFileWaitingForSize: intl.formatMessage(messages.FileWaitingForSize),
    labelFileSizeNotAvailable: intl.formatMessage(messages.FileSizeNotAvailable),
    labelFileLoading: intl.formatMessage(messages.Loading),
    labelFileLoadError: intl.formatMessage(messages.FileLoadError),
    labelFileProcessing: intl.formatMessage(messages.Uploading),
    labelFileProcessingComplete: intl.formatMessage(messages.FileProcessingComplete),
    labelFileProcessingAborted: intl.formatMessage(messages.FileProcessingAborted),
    labelFileProcessingError: intl.formatMessage(messages.FileProcessingError),
    labelTapToCancel: intl.formatMessage(messages.TapToCancel),
    labelTapToRetry: intl.formatMessage(messages.TapToRetry),
    labelTapToUndo: intl.formatMessage(messages.TapToUndo),
    labelButtonRemoveItem: intl.formatMessage(messages.Remove),
    labelButtonAbortItemLoad: intl.formatMessage(messages.Abort),
    labelButtonRetryItemLoad: intl.formatMessage(messages.Retry),
    labelButtonAbortItemProcessing: intl.formatMessage(messages.Abort),
    labelButtonUndoItemProcessing: intl.formatMessage(messages.Undo),
    labelButtonRetryItemProcessing: intl.formatMessage(messages.Retry),
    labelButtonProcessItem: intl.formatMessage(messages.Upload),
    labelMaxFileSize: intl.formatMessage(messages.MaxFileSize, { filesize: '100MB' }),
    labelMaxFileSizeExceeded: intl.formatMessage(messages.FileIsTooLarge),
    labelFileTypeNotAllowed: intl.formatMessage(messages.FileTypeNotAllowed),
  });

  render() {
    const { intl, pondRef, ...rest } = this.props;

    return (
      <FilePond
        {...this.getLabels(intl)}
        maxFileSize={104857601} // 100mb (cloudflare limit, plus one byte so error is shown)
        maxFiles={50}
        credits={undefined} // hide credits https://pqina.nl/filepond/docs/api/instance/properties/#disabling-credits
        ref={pondRef}
        onwarning={error => {
          if (error?.body === 'Max files') {
            ToastrService.error(intl.formatMessage(messages.MaxFilesOf50Exceeded));
          }
        }}
        {...rest}
      />
    );
  }

  static propTypes = {
    pondRef: PropTypes.func,
  };

  static defaultProps = {
    pondRef: () => {},
  };
}

export default injectIntl(TranslatedFilePond);
